export default __webpack_public_path__ + "img/rank2fh-96eeaa55.png";